import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { cryptoActions } from '../+state/crypto.actions';
import { cryptoFeature } from '../+state/crypto.reducers';
import {
  selectCryptosInitiallyLoaded,
  selectCryptosLoading,
  selectETPsInitiallyLoaded,
  selectETPsLoading,
  selectPopularCryptos,
} from '../+state/crypto.selectors';

@Injectable({ providedIn: 'root' })
export class CryptoFacade {
  readonly #store = inject(Store);

  public loadingCryptos$ = this.#store.select(selectCryptosLoading);
  public cryptosInitiallyLoaded$ = this.#store.select(selectCryptosInitiallyLoaded);
  public popularCryptos$ = this.#store.select(selectPopularCryptos);
  public cryptos$ = this.#store.select(cryptoFeature.selectCryptos);

  public loadingEtps$ = this.#store.select(selectETPsLoading);
  public etpsInitiallyLoaded$ = this.#store.select(selectETPsInitiallyLoaded);
  public etps$ = this.#store.select(cryptoFeature.selectEtps);

  public loadCryptos(): void {
    this.#store.dispatch(cryptoActions.loadCryptos());
  }

  public subscribeToCryptoQuotes(): void {
    this.#store.dispatch(cryptoActions.subscribeToCryptoQuotes());
  }

  public unsubscribeFromCryptoQuotes(): void {
    this.#store.dispatch(cryptoActions.unsubscribeFromCryptoQuotes());
  }

  public loadETPs(): void {
    this.#store.dispatch(cryptoActions.loadETPs());
  }

  public subscribeToETPQuotes() {
    this.#store.dispatch(cryptoActions.subscribeToETPQuotes());
  }

  public unsubscribeFromETPQuotes() {
    this.#store.dispatch(cryptoActions.unsubscribeFromETPQuotes());
  }
}
